export default __webpack_public_path__ + "static/media/fundo3.380c7ff3.jpg";